import { GALLERY, CLINIC } from "@/data/clinic";
import SEOHead from "@/components/SEOHead";
import { Link } from "react-router-dom";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <SEOHead
        title="Clinic Gallery | Dr. Ashutosh Mishra — Varanasi"
        description="A look inside the Diabetes & Endocrinology Clinic of Dr. Ashutosh Mishra in Kabir Nagar, Varanasi."
        path="/gallery"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Gallery", url: "/gallery" },
        ]}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <nav className="text-xs text-slate-500 mb-3">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Gallery</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Clinic gallery</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl text-slate-900 mt-3 leading-tight">Inside {CLINIC.doctorName}'s Clinic</h1>
          <p className="text-slate-600 text-lg mt-4 max-w-3xl">Moments from our Kabir Nagar, Varanasi clinic.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {GALLERY.map((g, i) => (
            <figure key={i} className="bg-white border border-slate-100 rounded-2xl overflow-hidden">
              <img src={g.src} alt={g.caption} className="w-full h-64 object-cover" />
              <figcaption className="p-3 text-sm text-slate-600">{g.caption}</figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
}
